import { RouteObject } from 'react-router-dom'
import UsuariosAcessosPage from '@/pages/usuarios/UsuariosAcessosPage'

/**
 * Rotas do A05 (Onda 2 — padrão de página do administrador). Integrado no merge (02/09):
 * `usuarios-acessos` assumiu o lugar do `PorAba` provisório do A02; a `VisaoCarteiraAdmin`
 * é despachada por papel no `DashboardPage` (rota provisória `/visao-carteira` removida).
 */
const rotasA05: RouteObject[] = [
  { path: 'usuarios-acessos', element: <UsuariosAcessosPage /> },
]

export default rotasA05
